export default __webpack_public_path__ + "static/upper2_3-317c06a57e1dd6a160c253de28fe4684.jpg";